module.exports = __webpack_public_path__ + "static/media/custom-3d-video.8c5d2869.mp4";